<script lang="ts" setup>
import { useI18n } from 'vue-i18n'

import { register } from 'timeago.js'
import arLocale from 'timeago.js/esm/lang/ar'
import frLocale from 'timeago.js/esm/lang/fr'

import { useLoadLocaleMessages } from '@kidzonet/vue-i18n-package'

import '@fortawesome/fontawesome-free/css/all.css'

interface SessionListProps {
    loading?: boolean
}
withDefaults(defineProps<SessionListProps>(), {
    loading: false,
})

const { locale, t } = useI18n()
if (locale.value === 'ar') {
    register('ar', arLocale)
}
if (locale.value === 'fr') {
    register('fr', frLocale)
}

useLoadLocaleMessages('sessions')
</script>

<template>
    <div>
        <slot name="header">
            <h2>{{ t('sessions.header') }}</h2>
        </slot>
        <v-progress-linear
            color="primary"
            indeterminate
            v-if="loading"
            height="2"
        />
        <TransitionGroup name="session-list-items">
            <slot name="item" />
        </TransitionGroup>
    </div>
</template>

<style>
    .session-list-items-leave-active {
        position: absolute;
        transition: all 0.5s ease;
    }
    .session-list-items-leave-to {
        transform: translateX(30px);
        opacity: 0;
    }
</style>
